import React, { useState, useEffect } from 'react'
import Form from "../../layouts/Form";
import { Grid, InputAdornment, makeStyles, ButtonGroup, Button as MuiButton } from '@material-ui/core';
import { Input, Select, Button } from "../../controls";
import ReplayIcon from '@material-ui/icons/Replay';
import PaidIcon from '@mui/icons-material/Paid';
import ReorderIcon from '@material-ui/icons/Reorder';
import { createAPIEndpoint, ENDPIONTS } from "../../api";
import { roundTo2DecimalPoint } from "../../utils";
import Notification from "../../layouts/Notification";
import InputLabel from '@mui/material/InputLabel';
import { green400 } from 'material-ui/styles/colors';

import CalculateIcon from '@mui/icons-material/Calculate';

const pMethods = [
    { id: 'none', title: 'Selecciona un método de pago' },
    { id: 'Transferencia Electronica', title: 'Transferencia Electrónica' },
    //{ id: 'Dinero Electrónico', title: 'Dinero Electrónico' },
    //{ id: 'IEC', title: 'IEC' },
    //{ id: 'Cajero', title: 'Cajero' },
    { id: 'Efectivo', title: 'Efectivo' },
    { id: 'Tarjeta Debito', title: 'Tarjeta Débito' },
    { id: 'Tarjeta Credito', title: 'Tarjeta Crédito' },
    { id: 'Cheque', title: 'Cheque' },
    { id: 'Diferentes metodos', title: 'Diferentes metodos' },
]

const facturaOpciones = [
    { id: 'none', title: 'Selecciona una opción' },
    { id: 'NO', title: 'NO' },
    { id: 'SI', title: 'SI' },
]

const ivaOpciones = [
    { id: 'none', title: 'Selecciona una opción' },
    { id: '0', title: '0%' },
    { id: '16', title: '16%' },
]

const comisionOpciones = [
    { id: 'none', title: 'Selecciona una opción' },
    { id: '3', title: '3%' },
]

const listanivelsiguienteciclo = [
    { id: 'none', title: 'Selecciona una opción' },
    { id: 'Kinder', title: 'Kinder' },
    { id: 'Preparatoria', title: 'Preparatoria' },
    { id: 'Primaria', title: 'Primaria' },
    { id: 'Secundaria', title: 'Secundaria' },
    
]

const listagradosiguienteciclo = [
    { id: 'none', title: 'Selecciona una opción' },
    { id: '1', title: '1' },
    { id: '2', title: '2' },
    { id: '3', title: '3' },
    { id: '4', title: '4' },
    { id: '5', title: '5' },
    { id: '6', title: '6' },
    { id: 'Maternal', title: 'Maternal' },
]



const listainscripcion = [
    { id: 'none', title: 'Selecciona una opción' },
    { id: 'SI', title: 'SI' },
    { id: 'NO', title: 'NO' },
]

const useStyles = makeStyles(theme => ({
    adornmentText: {
        '& .MuiTypography-root': {
            color: '#f3b33d',
            fontWeight: 'bolder',
            fontSize: '1.5em'
        }
    },
    submitButtonGroup: {
        backgroundColor: '#6666ff',
        color: 'white',
        margin: theme.spacing(1),
        '& .MuiButton-label': {
            textTransform: 'none'
        },
        '&:hover': {
            backgroundColor: '#f3b33d',
        }
    },
    submitButtonGroup2: {
        backgroundColor: '#f3b33d',
        color: 'white',
        margin: theme.spacing(1),
        '& .MuiButton-label': {
            textTransform: 'none',
            color: 'white',
        },
        '&:hover': {
            backgroundColor: '#f3b33d',
        }
    },

    ruleAlert: {
        backgroundColor: '#d32f2f',
        color: 'white',
        margin: theme.spacing(1),
        padding: theme.spacing(1.5),
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        boxShadow: '0 2px 4px rgba(0,0,0,0.20)'
    },
    ruleAlertMessage: {
        fontWeight: 600,
        lineHeight: 1.4,
        paddingRight: theme.spacing(2)
    },
    ruleAlertClose: {
        border: 0,
        background: 'transparent',
        color: 'white',
        fontSize: '20px',
        lineHeight: 1,
        cursor: 'pointer',
        padding: 0
    },
    ruleDetailButton: {
        marginLeft: '12px',
        marginTop: '8px',
        border: 0,
        background: 'transparent',
        color: '#b71c1c',
        fontWeight: 'bold',
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    ruleDetailPanel: {
        margin: theme.spacing(1),
        padding: theme.spacing(1.5),
        border: '1px solid #d32f2f',
        borderRadius: '4px',
        backgroundColor: '#fff8f8',
        overflowX: 'auto'
    },
    ruleDetailTable: {
        width: '100%',
        borderCollapse: 'collapse',
        '& th': {
            textAlign: 'left',
            padding: '8px',
            borderBottom: '2px solid #d32f2f',
            whiteSpace: 'nowrap'
        },
        '& td': {
            padding: '8px',
            borderBottom: '1px solid #e0e0e0',
            verticalAlign: 'top'
        }
    },
    labelAlumnoCarrito: {
        backgroundColor: '#e6e6e6',
        color: '#003399',
        margin:theme.spacing(1),
        fontSize: 'small'
    }
}))


const generateOrderNumber2 = () => Math.floor(100000 + Math.random() * 900000).toString();

const getFreshModelObject2 = () => ({
    orderMasterId: 0,
    orderNumber: generateOrderNumber2(),
    customerId: 0,
    pMethod: 'none',
    gTotal: 0,
    deletedOrderItemIds: '',
    orderDetails: [],
    idalumno: 0,
    idusuario: 0,
    alias: '',
    factura: 'none',
    rfc: '',
    correo: '',
    iva: 'none',
    comision: 'none',
    subtotal: 0,
    valorIva: 0,
    valorComision: 0,
    ajuste: 0,
    tipoajuste: '',
    motivoajuste: '',
    nivelsiguienteciclo: 'none',
    gradosiguienteciclo: 'none',
    siguienteciclo: 'none',
    realizarinscripcion: 'none',
    transferencia: 0,
    efectivo: 0,
    tarjetaDebito: 0,
    tarjetaCredito: 0,
    cheque: 0
})

const getFreshModelObjectMetodoPago= () => ({
    factura: 'none',
    iva: 'none',
    comision: 'none',
    transferencia: 0,
    efectivo: 0,
    tarjetaDebito: 0,
    tarjetaCredito: 0,
    cheque: 0
})


export default function OrderForm(props) {

    //console.log("---------***>" + JSON.stringify(props));

    const { values, setValues, errors, setErrors, handleInputChange, resetFormControls, nombrealumno, gradoalumno, nivelalumno, grupoalumno, alumnoid,correo2 } = props;
    const classes = useStyles();

    const [customerList, setCustomerList] = useState([]);
    const [customerList2, setCustomerList2] = useState([]);

    const [orderId, setOrderId] = useState(0);
    const [notify, setNotify] = useState({ isOpen: false });
    const [enviarpago, setEnviarpago] = useState(false);
    const [reglasBloqueadas, setReglasBloqueadas] = useState(null);
    const [mostrarDetalleReglas, setMostrarDetalleReglas] = useState(false);

    const [mostrarIva, setMostrarIva] = useState(false);
    //javier
    //const [mostrarComision, setMostrarComision] = useState(true);


    const [mostrarTiposPago, setMostrarTiposPago] = useState(false);

    const [cicloescolarsiguenteId, setCicloEscolarSiguiente] = useState(-1);

    const [mostrarnivelsiguienteciclo, setMostrarnivelsiguienteciclo] = useState(false);
    const [mostrargradosiguienteciclo, setMostrargradosiguienteciclo] = useState(false);

    const [mostrarsiguienteciclo, setMostrarsiguienteciclo] = useState(false);

    const [mostrarlabelsiguienteciclo, setMostrarlabelsiguienteciclo] = useState(false);


    //CICLO ESCOLAR Y SIGUIENTE CICLO
    useEffect(() => {
        createAPIEndpoint(ENDPIONTS.CICLO_ESCOLAR).fetchAll()
            .then(res => {
                let customerList = res.data.map(item => ({
                    id: item.idcicloescolar,
                    title: item.nombre
                }));

                let customerList2 = res.data.map(item => ({
                    id: item.idcicloescolar,
                    title: item.nombre
                }));

                customerList = [{ id: 0, title: 'Selecciona ciclo escolar' }].concat(customerList);
                customerList2 = [{ id: 0, title: 'Selecciona ciclo escolar' }].concat(customerList2);


                setCustomerList(customerList);
                setCustomerList2(customerList2);
            })
            .catch(err => console.log(err))


        createAPIEndpoint(ENDPIONTS.CICLO_ESCOLAR_SIGUIENTE).fetchCicloEscolarSiguiente()
            .then(res => {
                let _ciclo_escolar_siguiente = res.data;
                //console.log("----------------------------------------------CICLOR ESCOLAR SIGUIENTE " + _ciclo_escolar_siguiente);
                setCicloEscolarSiguiente(res.data);
            })
            .catch(err => console.log(err))
    }, [])
    

    //ORDER DETAILS
    useEffect(() => {
        //debugger;
        //console.log("----------------------------------------------SE EJECUTA CUANDO CAMBIA ORDER DETAILS ***>");

        let gTotal = values.orderDetails.reduce((tempTotal, item) => {
            let acumulado = 0;

            if (item.tipoajuste === "Sumar") {
                acumulado = (item.quantity * item.foodItemPrice) + item.ajuste;
            } else if (item.tipoajuste === "Restar") {
                acumulado = (item.quantity * item.foodItemPrice) - item.ajuste;
            } else {
                acumulado = (item.quantity * item.foodItemPrice);
			}
            
            return tempTotal + ( acumulado);
        }, 0);

        setValues({
            ...values,
            pMethod: 'none',
            factura: 'none',
            iva: 'none',
            comision: 'none',
            gTotal: roundTo2DecimalPoint(gTotal),
            subtotal: roundTo2DecimalPoint(gTotal),
            ajuste: 0,
            motivoajuste: ''
        })
        
    }, [JSON.stringify(values.orderDetails)]);


    //ORDER ID
    useEffect(() => {
        //debugger
        if (orderId == 0) {
            //console.log("ingresar por order id");
            //resetFormControls();
        } else {
            createAPIEndpoint(ENDPIONTS.ORDER).fetchById(orderId)
                .then(res => {
                    setValues(res.data);
                    setErrors({});
                })
                .catch(err => console.log(err))
        }
    }, [orderId]);


    //ID ALUMNO
    useEffect(() => {
        setValues({
            ...values,
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias'),
        })
        
    }, [alumnoid]);


    //CORREO
    useEffect(() => {
        //console.log("---CCAAAA>" + correo2);

        setValues({
            ...values,
            correo: correo2
        })

    }, [correo2]);


    //FACTURA
    useEffect(() => {
        if (values.factura === "SI") {
            setMostrarIva(true);
        }

        if (values.factura === "NO") {
            setMostrarIva(false);
        }

        
    }, [values.factura]);


    //SELECCIONA QUE SI DESEA INSCRIBIR
    useEffect(() => {
        //debugger;


        setMostrarlabelsiguienteciclo(false);

        if (values.realizarinscripcion === "SI") { 
            setMostrarnivelsiguienteciclo(true);
            setMostrargradosiguienteciclo(true);
            setMostrarsiguienteciclo(true);
        } else {
            setMostrarnivelsiguienteciclo(false);
            setMostrargradosiguienteciclo(false);
            setMostrarsiguienteciclo(false);
        }
        /*
        console.log("------CICLOR ESCOLAR SELECCIONADO ***>" + );
        console.log("------CICLOR ESCOLAR VIGENTE ***>" + );
        */

    }, [values.realizarinscripcion]);


    //CICLO ESCOLAR SIGUIENTE
    useEffect(() => {
        //debugger

        let _cicloseleccionado      = parseInt(values.siguienteciclo);
        let _siguientecicloescolar  = parseInt(cicloescolarsiguenteId);

        if (_siguientecicloescolar === -1) {
            setMostrarlabelsiguienteciclo(false);
            return;
        } 

        if (_cicloseleccionado === _siguientecicloescolar) {
            setMostrarlabelsiguienteciclo(false);
        } else {
            setMostrarlabelsiguienteciclo(true);
        }

    }, [values.siguienteciclo]);


    //METODO DE PAGO
    useEffect(() => {
        //debugger;
        resetFormMetodoPago();

        
        let _ajuste = 0;

        let _gTotal = values.orderDetails.reduce((tempTotal, item) => {
            let acumulado = 0;

            if (item.tipoajuste === "Sumar") {
                acumulado = (item.quantity * item.foodItemPrice) + item.ajuste;
            } else if (item.tipoajuste === "Restar") {
                acumulado = (item.quantity * item.foodItemPrice) - item.ajuste;
            } else {
                acumulado = (item.quantity * item.foodItemPrice);
            }

            return tempTotal + (acumulado);
        }, 0);

        //javier
        /*
        if (values.pMethod === "Tarjeta Debito" || values.pMethod === "Tarjeta Credito" || values.pMethod === "Diferentes metodos") {
            setMostrarComision(true);
        } else {
            setMostrarComision(false);
        }
        */

        if (values.pMethod === "Diferentes metodos") {
            let transferencia   = (values.transferencia === "") ? 0 : parseFloat(values.transferencia);
            let efectivo        = (values.efectivo === "") ? 0 : parseFloat(values.efectivo);
            let tarjetaDebito   = (values.tarjetaDebito === "") ? 0 : parseFloat(values.tarjetaDebito);
            let tarjetaCredito  = (values.tarjetaCredito === "") ? 0 : parseFloat(values.tarjetaCredito);
            let cheque          = (values.cheque === "") ? 0 : parseFloat(values.cheque);
       
            setValues({
                ...values,
                transferencia: transferencia,
                efectivo: efectivo,
                tarjetaDebito: tarjetaDebito,
                tarjetaCredito: tarjetaCredito,
                cheque: cheque
            });

            setMostrarTiposPago(true);
        } else { 
            setMostrarTiposPago(false);
        }

        

        setValues({
            ...values,
            factura: 'none',
            iva: 'none',
            comision: 'none',
            ajuste: _ajuste,
            gTotal: roundTo2DecimalPoint(_gTotal),
        })

    }, [values.pMethod]);


    //COMISION E IVA
    useEffect(() => {
        debugger;

        let gComision   = 0;
        let gIva        = 0;

        let _valorIva       =0;
        let _valorComision  =0;

        //javier
        /*
        if (values.comision !== 'none') {
            gComision = values.comision;
        } 
        */

        if (values.iva !== 'none') {
            gIva = values.iva
        } 

        
        let _ajuste = 0;
        let _gTotal = 0;
        

        _gTotal = values.orderDetails.reduce((tempTotal, item) => {
            let acumulado = 0;

            if (item.tipoajuste === "Sumar") {
                acumulado = (item.quantity * item.foodItemPrice) + item.ajuste;
            } else if (item.tipoajuste === "Restar") {
                acumulado = (item.quantity * item.foodItemPrice) - item.ajuste;
            } else {
                acumulado = (item.quantity * item.foodItemPrice);
            }

            return tempTotal + (acumulado);
        }, 0);

        //console.log("----event comision ------------>gTotal " + _gTotal);
        let tarjetaDebito   = 0;
        let tarjetaCredito  = 0;
        let _gTotal2        = 0;
        if (values.pMethod === "Diferentes metodos") {
            tarjetaDebito = (values.tarjetaDebito === "") ? 0 : parseFloat(values.tarjetaDebito) ;
            tarjetaCredito = (values.tarjetaCredito === "") ? 0 : parseFloat(values.tarjetaCredito);

            _gTotal2 = tarjetaDebito + tarjetaCredito;

            //javier
            //_valorComision = _gTotal2 * (parseFloat(gComision) / 100);
        } else { 
            //javier
            //_valorComision = _gTotal * (parseFloat(gComision) / 100);
        }

        //javier - se agrego para que siempre sea cero
        _valorComision = 0;

        let gTotal      = 0;
        if (parseFloat(gIva) !== 0) {
            _valorIva = (_gTotal + _valorComision) * (parseFloat(gIva) / 100);
            gTotal = _gTotal + _valorComision + _valorIva;
        } else {
            gTotal = (_gTotal + _valorComision);
        }

        
        setValues({
            ...values,
            gTotal: roundTo2DecimalPoint(gTotal),
            subtotal: roundTo2DecimalPoint(_gTotal),
            valorIva: roundTo2DecimalPoint(_valorIva),
            valorComision: roundTo2DecimalPoint(_valorComision),
            ajuste:_ajuste
        })

    }, [values.comision, values.iva]);



    const validateForm = () => {
        //debugger;
        let temp                    = {};

        temp.factura                = values.factura !== "none" ? "" : "¡Este campo es obligatorio!";
        temp.customerId             = values.customerId !== 0 ? "" : "¡Este campo es obligatorio!";
        temp.pMethod                = values.pMethod !== "none" ? "" : "¡Este campo es obligatorio!";
        temp.orderDetails           = values.orderDetails.length !== 0 ? "" : "¡Este campo es obligatorio!";
        temp.iva                    = "";
        temp.comision               = "";
        temp.rfc                    = "";
        temp.motivoajuste           = "";
        temp.ajuste                 = "";
        temp.nivelsiguienteciclo    = "";
        temp.gradosiguienteciclo    = "";
        temp.siguienteciclo         = "";
        
        /*
        let _tmpAjuste = values.orderDetails.reduce((tempTotal, item) => {
            let acumulado = 0;

            acumulado += item.ajuste;

            return tempTotal + (acumulado);
        }, 0);
        if (parseFloat(_tmpAjuste) > 0 && values.motivoajuste==="") {
            temp.motivoajuste = "¡Tienes un ajustes parciales, por tanto debes ingresar el motivo de ajuste!";
        }
        */


        if (values.factura === "SI") {
            /*
            if (values.rfc === "") {
                temp.rfc = "¡Este campo es obligatorio!";
            }
            */

            if (values.iva === "none") {
                temp.iva = "¡Este campo es obligatorio!";
            }

        }

        //javier
        /*
        if (values.pMethod === "Tarjeta Debito" || values.pMethod === "Tarjeta Credito") {
            if (values.comision === "none") {
                temp.comision = "¡Este campo es obligatorio!";
            }

        }
        */

        let transferencia   = (values.transferencia === "") ? 0 : parseFloat(values.transferencia);
        let efectivo        = (values.efectivo === "") ? 0 : parseFloat(values.efectivo);
        let tarjetaDebito   = (values.tarjetaDebito === "") ? 0 : parseFloat(values.tarjetaDebito);
        let tarjetaCredito  = (values.tarjetaCredito === "") ? 0 : parseFloat(values.tarjetaCredito);
        let cheque          = (values.cheque === "") ? 0 : parseFloat(values.cheque);
       
        setValues({
            ...values,
            transferencia: transferencia,
            efectivo: efectivo,
            tarjetaDebito: tarjetaDebito,
            tarjetaCredito: tarjetaCredito,
            cheque: cheque
        });
        

        if (values.pMethod === "Diferentes metodos") {

            //javier
            /*
            if (values.tarjetaDebito !== 0 || values.tarjetaCredito !== 0) {
                if (values.comision === "none") {
                    temp.comision = "¡Este campo es obligatorio!";
                }
            }
            */

            //falta considerar comision e iva
            let _tempTotal = transferencia +
                efectivo +
                tarjetaDebito +
                tarjetaCredito +
                cheque;

            temp.gTotal = "";

            let _totalmetodopago = 0;
            if (transferencia > 0) _totalmetodopago++;
            if (efectivo > 0) _totalmetodopago++;
            if (tarjetaDebito > 0) _totalmetodopago++;
            if (tarjetaCredito > 0) _totalmetodopago++;
            if (cheque > 0) _totalmetodopago++;
            if (_totalmetodopago<2) {
                temp.gTotal = "Debe existir al menos dos métodos diferentes de pago.";
                setNotify({ isOpen: true, message: '¡Debe existir al menos dos métodos diferentes de pago!' });
            }

            if (values.gTotal !== _tempTotal) {
                temp.gTotal = "Los diferentes métodos de pagos no cubren el monto total a pagar";
                setNotify({ isOpen: true, message: '¡El pago NO puede ser efectuado, porque no cubre el monto total a pagar!' });
            }

        }//END IF



        //if (parseInt(values.customerId) === parseInt(cicloescolarsiguenteId)) {
        if (values.realizarinscripcion === "SI") { 
            if (values.nivelsiguienteciclo === "none") {
                temp.nivelsiguienteciclo = "¡Este campo es obligatorio!";
            }
            if (values.gradosiguienteciclo === "none") {
                temp.gradosiguienteciclo = "¡Este campo es obligatorio!";
            }

            if (values.siguienteciclo === "none") {
                temp.siguienteciclo = "¡Este campo es obligatorio!";
            }

        }


        setErrors({ ...temp });
        return Object.values(temp).every(x => x === "");
    }

    const resetForm = () => {

        setValues({
            ...getFreshModelObject2(),
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias'),

        });

        setOrderId(0);
        setReglasBloqueadas(null);
        setMostrarDetalleReglas(false);
    }


    const calculoResto = () => {
        //debugger 

        let transferencia   = (values.transferencia === "") ? 0 : parseFloat(values.transferencia);
        let efectivo        = (values.efectivo === "") ? 0 : parseFloat(values.efectivo);
        let tarjetaDebito   = (values.tarjetaDebito === "") ? 0 : parseFloat(values.tarjetaDebito);
        let tarjetaCredito  = (values.tarjetaCredito === "") ? 0 : parseFloat(values.tarjetaCredito);
        let cheque          = (values.cheque === "") ? 0 : parseFloat(values.cheque);


        let _tempTotal = transferencia +
                        efectivo +
                        tarjetaDebito +
                        tarjetaCredito +
                        cheque;

        	

        let str = `Monto a cubrir ${roundTo2DecimalPoint(parseFloat(values.gTotal) - _tempTotal)} - Acumulado ${roundTo2DecimalPoint(_tempTotal)}`;

        setNotify({ isOpen: true, message: str });

    }


    const resetFormMetodoPago = () => {
        
        //debugger;

        setValues({
            ...getFreshModelObjectMetodoPago(),
            pMethod: values.pMethod,
            orderDetails: values.orderDetails,
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias'),
            transferencia: 0,
            efectivo: 0,
            tarjetaDebito: 0,
            tarjetaCredito: 0,
            cheque: 0
        });


        setOrderId(0);

        //javier
        //setMostrarComision(false);

        setMostrarIva(false);
    }

    const submitOrder = e => {
        //debugger
        e.preventDefault();


        if (validateForm()) {


            
            if (values.orderMasterId === 0) {

                console.log("---AAAAA------***>" + JSON.stringify(values));
                setMostrarlabelsiguienteciclo(false);
                
                setEnviarpago(true);
                createAPIEndpoint(ENDPIONTS.ORDER).create(values)
                    .then(res => {
                        resetForm();
                        setReglasBloqueadas(null);
                        setMostrarDetalleReglas(false);
                        setNotify({ isOpen: true, message: '¡El pago ha sido realizado!' });
                        setEnviarpago(false);
                        setMostrarlabelsiguienteciclo(false);
                    })
                    .catch(err => {
                        setEnviarpago(false);

                        // El backend es la única fuente de verdad para estas reglas.
                        // React únicamente presenta el veredicto y, para colegiatura,
                        // habilita la liga al detalle de pagos cumplidos/pendientes.
                        if (err.response && err.response.status === 400 && err.response.data) {
                            if (err.response.data.esValidacionReglasColegiatura) {
                                setReglasBloqueadas(err.response.data);
                                setMostrarDetalleReglas(false);
                                return;
                            }

                            if (err.response.data.esValidacionCobroServicioRegla) {
                                setReglasBloqueadas(err.response.data);
                                setMostrarDetalleReglas(false);
                                return;
                            }
                        }

                        setNotify({ isOpen: true, message: 'No fue posible realizar el pago. Intenta nuevamente.' });
                        console.log(err);
                    });
                
            }else {
                createAPIEndpoint(ENDPIONTS.ORDER).update(values.orderMasterId, values)
                    .then(res => {
                        setOrderId(0);
                        setNotify({ isOpen: true, message:'¡El pago ha sido realizado!'});
                    })
                    .catch(err => console.log(err));
            }
            

        }//END IF

    }//END METHOD

    const openListOfOrders = () => {
        window.open('/historialpago', '_blank', 'noopener,noreferrer');
    }

    //ESTE SE USABA PARA EL AJUSTE DE MANERA GENERICA
    const updatePrice = (tipo) => {
        //debugger;
        
        let _gTotal = values.gTotal;
        let gTotalAjuste = 0;


        if (_gTotal > 0) {
            let gTotalAjuste = 0;
            let _ajuste = 0;

            //console.log("----event AJUSTE ------------>Grand Total " + _gTotal);
            //console.log("----event AJUSTE ------------>AJUSTE " + values.ajuste);

            if (tipo === "sumar") {
                gTotalAjuste = _gTotal + parseFloat(values.ajuste);
                _ajuste = parseFloat(values.ajuste);
            }

            if (tipo === "restar") {
                gTotalAjuste = _gTotal - parseFloat(values.ajuste);
                _ajuste = parseFloat(values.ajuste)*-1;
            }

            //console.log("tipo----->" + tipo);
            
            setValues({
                ...values,
                gTotal: roundTo2DecimalPoint(gTotalAjuste),
                tipoajuste: tipo,
                pMethod: 'none',
                factura: 'none',
                iva: 'none',
                comision: 'none',
                ajuste:values.ajuste
            })

        }//end if

    }



    return (
        <>
            {reglasBloqueadas && (
                <div className={classes.ruleAlert}>
                    <div className={classes.ruleAlertMessage}>
                        {reglasBloqueadas.mensaje ||
                            'El pago fue bloqueado por una regla de negocio.'}
                    </div>
                    <button
                        type="button"
                        className={classes.ruleAlertClose}
                        onClick={() => {
                            setReglasBloqueadas(null);
                            setMostrarDetalleReglas(false);
                        }}
                        aria-label="Cerrar"
                    >
                        ×
                    </button>
                </div>
            )}

            {reglasBloqueadas &&
                mostrarDetalleReglas &&
                reglasBloqueadas.detalles &&
                reglasBloqueadas.detalles.length > 0 && (
                <div className={classes.ruleDetailPanel}>
                    <div style={{ fontWeight: 'bold', marginBottom: '10px', color: '#b71c1c' }}>
                        Detalle de requisitos para pago de colegiatura
                    </div>

                    <table className={classes.ruleDetailTable}>
                        <thead>
                            <tr>
                                <th>Concepto</th>
                                <th>Regla</th>
                                <th>Nivel</th>
                                <th>Periodicidad</th>
                                <th>Modalidad</th>
                                <th>Periodo</th>
                                <th>Estatus</th>
                                <th>Evidencia</th>
                                <th>Fecha</th>
                                <th>Monto</th>
                                <th>Motivo / observación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reglasBloqueadas.detalles.map((item, index) => {
                                const fecha = item.fechaPago || item.fechaEvidencia;
                                const motivo = item.motivoEvidencia
                                    ? `${item.motivoEvidencia}. ${item.observacion || ''}`
                                    : item.observacion;

                                return (
                                    <tr key={`${item.idreglacolegiaturaalumno}-${item.clavePeriodo}-${index}`}>
                                        <td>{item.concepto || '-'}</td>
                                        <td>{item.tipoRegla || '-'}</td>
                                        <td>{item.nivel || '-'}</td>
                                        <td>{item.periodicidad || '-'}</td>
                                        <td>{item.modalidad || '-'}</td>
                                        <td>{item.periodo || '-'}</td>
                                        <td style={{
                                            fontWeight: 'bold',
                                            color: item.cumple ? '#2e7d32' : '#c62828'
                                        }}>
                                            {item.estatus || '-'}
                                        </td>
                                        <td>{item.tipoEvidencia || '-'}</td>
                                        <td>{fecha ? new Date(fecha).toLocaleString() : '-'}</td>
                                        <td>
                                            {item.montoPagado != null
                                                ? `$${Number(item.montoPagado).toFixed(2)}`
                                                : '-'}
                                        </td>
                                        <td>{motivo || '-'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            <Form onSubmit={submitOrder}>
                <Grid container>
                    <Grid item xs={6}>


                        { 
/*
                        <Input
                            disabled
                            label="Número De Folio"
                            name="orderNumber"
                            value={values.orderNumber}
                            InputProps={{
                                startAdornment: <InputAdornment
                                    className={classes.adornmentText}
                                    position="start">#</InputAdornment>
                            }}
                        />
*/
                        }


                        <InputLabel className={classes.submitButtonGroup2}>
                            {nombrealumno}
                            <br/>
                            {gradoalumno} {nivelalumno} - {grupoalumno}
                        </InputLabel>
                       
                        <Select
                            label="Ciclo Escolar En Que Se Cobra - Sólo es aplicable a inscripcón"
                            name="customerId"
                            value={values.customerId}
                            onChange={handleInputChange}
                            options={customerList}
                            error={errors.customerId} />

                        <Select
                            label="¿Deseas Realizar Inscripción?"
                            name="realizarinscripcion"
                            value={values.realizarinscripcion}
                            onChange={handleInputChange}
                            options={listainscripcion}
                            error={errors.realizarinscripcion} />


                            
                             {
                                mostrarnivelsiguienteciclo ? (
                                <Select
                                    label="Siguiente Nivel"
                                    name="nivelsiguienteciclo"
                                    value={values.nivelsiguienteciclo}
                                    onChange={handleInputChange}
                                    options={listanivelsiguienteciclo}
                                    error={errors.nivelsiguienteciclo} />

                                ) : (
                                        null
                                    )
                            }



                            {
                            mostrargradosiguienteciclo ? (
                                <Select
                                    label="Siguiente Grado"
                                    name="gradosiguienteciclo"
                                    value={values.gradosiguienteciclo}
                                    onChange={handleInputChange}
                                    options={listagradosiguienteciclo}
                                    error={errors.gradosiguienteciclo} />
                            ): (
                                    null
                                )
                            }

                            {
                            mostrarsiguienteciclo ? (
                                <Select
                                    label="Definir El Siguiente Ciclo Escolar A Cursar"
                                    name="siguienteciclo"
                                    value={values.siguienteciclo}
                                    onChange={handleInputChange}
                                    options={customerList2}
                                    error={errors.siguienteciclo} />
                            ): (
                                    null
                                )
                            }

                            {
                            mostrarlabelsiguienteciclo ? (
                                <label style={{ fontWeight: "bold", color: "#0000ff" }}>El ciclo escolar seleccionado no está definido como el siguiente ciclo escolar</label>
                            ): (
                                    null
                                )
                            }

                        <Input
                            label="RFC"
                            name="rfc"
                            value={values.rfc}
                            onChange={handleInputChange}
                            error={errors.rfc}
                        />

                        <Input
                            label="Correo Electrónico"
                            name="correo"
                            value={values.correo}
                            onChange={handleInputChange}
                        />

                    </Grid>

                    <Grid item xs={6}>

                        <Input
                            disabled
                            label="Total"
                            name="gTotal"
                            value={values.gTotal}
                            InputProps={{
                                startAdornment: <InputAdornment
                                    className={classes.adornmentText}
                                    position="start">$</InputAdornment>
                            }}
                            error={errors.gTotal}
                        />


                        {

                            mostrarTiposPago ? (
                                <ButtonGroup className={classes.submitButtonGroup}>
                                    <MuiButton
                                        size="small"
                                        onClick={calculoResto}
                                        startIcon={<CalculateIcon />}
                                    />
                                </ButtonGroup>

                            ): (
                                    null
                                )
}

 


                        <Input
                            label="Motivo Ajuste"
                            name="motivoajuste"
                            value={values.motivoajuste}
                            onChange={handleInputChange}
                            error={errors.motivoajuste}
                            hidden
                        />


                        <Select
                            label="Método De Pago"
                            name="pMethod"
                            value={values.pMethod}
                            onChange={handleInputChange}
                            options={pMethods}
                            error={errors.pMethod}
                        />


                        <Select
                            label="¿Facturar?"
                            name="factura"
                            value={values.factura}
                            onChange={handleInputChange}
                            options={facturaOpciones}
                            error={errors.factura}
                        />



                        {
                            mostrarIva ? (
                                <Select
                                    label="I.V.A"
                                    name="iva"
                                    value={values.iva}
                                    onChange={handleInputChange}
                                    options={ivaOpciones}
                                    error={errors.iva}

                                />

                            ) : (
                                null

                            )

                        }



                        {

                            mostrarTiposPago ? (

                                <div>
                                    < Input
                                        label="Transferencia Electrónica"
                                        name="transferencia"
                                        value={values.transferencia}
                                        onChange={handleInputChange}
                                        error={errors.transferencia}
                                        type="number"
                                    />

                                    <Input
                                        label="Efectivo"
                                        name="efectivo"
                                        value={values.efectivo}
                                        onChange={handleInputChange}
                                        error={errors.efectivo}
                                        type="number"
                                    />

                                    <Input
                                        label="Tarjeta Débito"
                                        name="tarjetaDebito"
                                        value={values.tarjetaDebito}
                                        onChange={handleInputChange}
                                        error={errors.tarjetaDebito}
                                        type="number"
                                    />

                                    <Input
                                        label="Tarjeta Crédito"
                                        name="tarjetaCredito"
                                        value={values.tarjetaCredito}
                                        onChange={handleInputChange}
                                        error={errors.tarjetaCredito}
                                        type="number"
                                    />

                                    <Input
                                        label="Cheque"
                                        name="cheque"
                                        value={values.cheque}
                                        onChange={handleInputChange}
                                        error={errors.cheque}
                                        type="number"
                                    />

                                </div>                            

                            ):(
                                null
                            )
                        }


                        {/*
                            mostrarComision ? (
                                <Select
                                    label="Comisión Tarjeta"
                                    name="comision"
                                    value={values.comision}
                                    onChange={handleInputChange}
                                    options={comisionOpciones}
                                    error={errors.comision}
                                />

                            ) : (
                                null
                            )
                            */
                        }





                        {
                            enviarpago ? (
                                <ButtonGroup className={classes.submitButtonGroup} disabled>
                                    <MuiButton
                                        size="large"
                                        endIcon={<PaidIcon />}
                                        type="submit">PROCESANDO PAGO</MuiButton>
                                    <MuiButton
                                        size="small"
                                        onClick={resetForm}
                                        startIcon={<ReplayIcon />}
                                    />
                                </ButtonGroup>
                               
                            ) : (
                                <ButtonGroup className={classes.submitButtonGroup}>
                                    <MuiButton
                                        size="large"
                                        endIcon={<PaidIcon />}
                                        type="submit">PAGAR</MuiButton>
                                    <MuiButton
                                        size="small"
                                        onClick={resetForm}
                                        startIcon={<ReplayIcon />}
                                    />
                                </ButtonGroup>
                                    
                            )

                        }
                        <Button
                            size="large"
                            onClick={openListOfOrders}
                            startIcon={<ReorderIcon />}
                        >HISTORIAL PAGOS</Button>

                        {reglasBloqueadas &&
                            reglasBloqueadas.detalles &&
                            reglasBloqueadas.detalles.length > 0 && (
                            <button
                                type="button"
                                className={classes.ruleDetailButton}
                                onClick={() => setMostrarDetalleReglas(!mostrarDetalleReglas)}
                            >
                                {mostrarDetalleReglas
                                    ? 'Ocultar detalle de requisitos'
                                    : 'Ver detalle de requisitos pendientes'}
                            </button>
                        )}



                    </Grid>
                </Grid>
            </Form>
            <Notification
                {...{ notify, setNotify }} />
        </>
    )
}
